
import React,{Component} from 'react'


export default class Map extends Component {
    onLoad = () => {
        const map = new window.google.maps.Map(
            document.getElementById(this.props.id),
            this.props.options
        )
        this.props.onMount(map)
    }

    componentDidMount() {
        if (!window.google) {
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = `https://maps.google.com/maps/api/js?key=AIzaSyDUeHtAkem-uyzvMGk8Zz_20WSTID02Ojc`
            const headScript = document.getElementsByTagName('script')[0]
            headScript.parentNode.insertBefore(script, headScript)
            script.addEventListener('load', () => {
                this.onLoad()
            })
        } else {
            this.onLoad()
        }
    }

    render() {
        const {options} = this.props
        return <div style={{ height: `100%` }}>
            <div style={{ height: `100%` }} id={this.props.id}></div>
            <a className="address" href={`https://maps.google.com/?q=Hubbler, 12th Main Road, 3rd Block, Koramangala, Bengaluru, Karnataka`} target={'_blank'}>View larger map</a>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Map.js